import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../_metronic/layout/core'
import { toast } from 'react-toastify';
import { KTCard, KTCardBody, Loader, enumPolicies } from '../../../../_metronic/helpers'
import { PRIMARY_COLOR } from '../../../../_metronic/helpers/colorConstant';
import Swal from 'sweetalert2'
import PolicyChecker from '../../../../_metronic/helpers/components/PolicyChecker';

import { clearState, getCategoryList, postCategory, patchCategory, deleteCategory } from './categoryActions';
import CategoryListTable from './CategoryListTable';
import CategoryModal from './CategoryModal';

const CategoryPage = (props) => {
    const intl = useIntl()
    
    //inputs from redux
    const {
        categoryList,
        loading,
        success
    } = props;

    //actions
    const {
        clearState,
        getCategoryList,
        postCategory,
        patchCategory,
        deleteCategory
    } = props;


    const [keyword, setKeyword] = useState();
    const [showModal, setShowModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);

    useEffect(() => {
        getCategoryList();
        return () => {
            clearState()
        }
    }, []);

    useEffect(() => {
        if (success) {
            toast.success(intl.formatMessage({ id: success }));
            setShowModal(false);
            setSelectedCategory(null);
            getCategoryList(keyword);
        }
    }, [success])


    useEffect(() => {
        if (keyword != undefined) {
            const timeOutId = setTimeout(() => getCategoryList(keyword), 400);
            return () => clearTimeout(timeOutId);
        }
    }, [keyword]);

    const breadcrumbs = [
        {
            title: intl.formatMessage({ id: 'CATALOG.MANAGEMENT.TITLE' }),
            path: '/catalog-management/categories',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,        }
    ]

    const onSearch = (value) => {
        setKeyword(value);
    }

    const onEdit = (item) => {
        setSelectedCategory(item);
        setShowModal(true);
    }

    const onDelete = (id) => {
        Swal.fire({
            title: intl.formatMessage({ id: 'GENERAL.SURE' }),
            text: intl.formatMessage({ id: 'CATEGORY.DELETE.CONFIRMATION' }),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: PRIMARY_COLOR,
            cancelButtonColor: "#dbdfe9",
            confirmButtonText: intl.formatMessage({ id: 'GENERAL.YES' })
        }).then((result) => {
            if (result.isConfirmed) {
                deleteCategory(id)
            }
        });
    }

    const onModalSubmit = (values) => {
        if (selectedCategory) {
            patchCategory(selectedCategory.id, values);
        } else {
            postCategory(values);
        }
    }

    const onAddClick = () => {
        setSelectedCategory(null);
        setShowModal(true);
    }

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs} >{intl.formatMessage({ id: 'CATEGORY.LIST.BREADCRUMB' })}</PageTitle>

            <KTCard>

                <div className="card-header border-0 pt-6">
                    <div className="card-title">
                        <div className="d-flex align-items-center position-relative my-1">
                            <i className="ki-duotone ki-magnifier fs-1 position-absolute ms-6">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                            <input type="text" data-kt-user-table-filter="search" className="form-control form-control-solid w-250px ps-14" placeholder={intl.formatMessage({ id: 'CATEGORY.LIST.SEARCH.CATEGORY' })} value={keyword} onChange={(e) => onSearch(e.target.value)} />
                        </div>
                    </div>
                    
                    <PolicyChecker policies={[enumPolicies.ProductWrite]}>
                        <div className="card-toolbar">
                            <div className="d-flex justify-content-end" data-kt-user-table-toolbar="base">
                                <button type="button" className="btn btn-success" onClick={onAddClick}><i className="ki-duotone ki-plus fs-2"></i>{intl.formatMessage({ id: 'CATEGORY.LIST.ADD.CATEGORY' })}</button>
                            </div>
                        </div>
                    </PolicyChecker>

                </div>
                <KTCardBody className='table-responsive m-grid-responsive-md'>

                    <CategoryListTable 
                        data={categoryList} 
                        intl={intl} 
                        onEdit={onEdit} 
                        onDelete={onDelete}
                    />

                </KTCardBody>
            </KTCard >
            <CategoryModal 
                show={showModal} 
                onHide={() => setShowModal(false)} 
                onSubmit={onModalSubmit} 
                category={selectedCategory}
                loading={loading}
            />
            {loading && <Loader></Loader>}
        </>
    );
};

const mapStateToProps = state => {
    return {
        categoryList: state.Category.categoryList,
        loading: state.Category.loading,
        success: state.Category.success
    };
};

const mapActionsToProps = {
    clearState, getCategoryList, postCategory, patchCategory, deleteCategory
}

export default connect(mapStateToProps, mapActionsToProps)(CategoryPage)
